// VeeValidate 4.x API
import { defineRule, configure } from 'vee-validate';
import { email as emailRule } from '@vee-validate/rules';

export default function addVeeValidateRules (defineRuleFn, configureFn) {
  // Use the passed functions (for compatibility)
  const define = defineRuleFn || defineRule;
  const config = configureFn || configure;

  define('required', (value) => {
    if (value === null || value === undefined || String(value).trim() === '') {
      return 'To pole jest wymagane';
    }
    return true;
  });

  define('email', (value) => {
    if (!value || !value.length) {
      return true;
    }
    // Simple email regex
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'To pole musi zawierać poprawny adres e-mail';
    }
    return true;
  });

  define('valid-url', (value) => {
    if (!value || value.trim() === '') {
      return true;
    }

    let urlPattern = new RegExp('^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$', 'i');
    if (!urlPattern.test(value)) {
      return 'To pole musi zawierać poprawny adres URL';
    }
    return true;
  });

  define('only-big-letters', (value) => {
    if (value !== value.replace(/[^A-Z]/gm, '')) {
      return 'To pole może zawierać wyłącznie duże litery';
    }
    return true;
  });

  define('only-numbers', (value) => {
    if (value !== value.replace(/[^0-9.]/gm, '') || Number.isNaN(parseFloat(value.replace(/[^0-9.]/gm, '')))) {
      return 'To pole musi zawierać liczbę';
    }
    return true;
  });

  define('only-letters-and-dashes', (value) => {
    if (value !== value.replace(/[^a-zA-Z-]/gm, '')) {
      return 'To pole może zawierać wyłącznie litery i myślniki';
    }
    return true;
  });

  define('min', (value, [min]) => {
    if (!value || value.length < min) {
      if (min === 1) {
        return 'To pole musi zawierać co najmniej jeden znak';
      }
      if (min >= 2 && min <= 4) {
        return `To pole musi zawierać co najmniej ${min} znaki`;
      }
      return `To pole musi zawierać co najmniej ${min} znaków`;
    }
    return true;
  });

  define('max', (value, [max]) => {
    if (value && value.length > max) {
      if (max === 1) {
        return 'To pole może zawierać maksymalnie jeden znak';
      }
      if (max >= 2 && max <= 4) {
        return `To pole może zawierać maksymalnie ${max} znaki`;
      }
      return `To pole może zawierać maksymalnie ${max} znaków`;
    }
    return true;
  });

  define('min_value', (value, [minValue]) => {
    if (parseFloat(value) < parseFloat(minValue)) {
      return `Wartość nie może być mniejsza niż ${minValue}`;
    }
    return true;
  });

  define('max_value', (value, [maxValue]) => {
    if (parseFloat(value) > parseFloat(maxValue)) {
      return `Wartość nie może być większa niż ${maxValue}`;
    }
    return true;
  });

  define('password', (value, [target], ctx) => {
    const targetValue = ctx && ctx.form ? ctx.form[target] : target;
    if ((value || '') !== (targetValue || '')) {
      return 'Hasła nie są identyczne';
    }
    return true;
  });

  // Configure VeeValidate (optional)
  if (config) {
    config({
      generateMessage: (ctx) => {
        return ctx.rule?.message || `Pole ${ctx.field} jest nieprawidłowe`;
      },
    });
  }
}

